angular.module('aq.filters.math')
.filter('compareValues', function() {
    return function(inputValue, valueToCompare) {
        if (!inputValue || !valueToCompare) return 0;
        var v1 = parseFloat(valueToCompare);
        var v2 = parseFloat(inputValue);
        return Math.round(((v2 - v1)/ Math.abs(v1)) * 100);
    };
});